import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';
import { InboxClassificationFilter } from 'owa-mail-list-store';
import { addDatapointConfig } from 'owa-analytics-actions';

export const moveRowsToInboxPlusPivot = action(
    'MOVE_ROWS_TO_INBOX_PLUS_PIVOT',
    (
        rowKeys: string[],
        destinationPivot: InboxClassificationFilter,
        tableViewId: string,
        actionSource: ActionSource
    ) =>
        addDatapointConfig(
            {
                name: 'TnS_MoveRowsToInboxPlusPivot',
            },
            {
                rowKeys,
                destinationPivot,
                tableViewId,
                actionSource,
            }
        )
);
